import {defineSlotRecipe} from '@chakra-ui/react3'

const displayPriceRecipe = defineSlotRecipe({
    slots: [
        'container',
        'priceOrder',
        'originalPrice',
        'priceContainer',
        'price',
        'freeLabel',
        'taxesLabel'
    ],
    base: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start'
        },
        priceOrder: {
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 'spacing-4'
        },
        originalPrice: {
            backgroundColor: 'background.actions.ghost',
            borderRadius: 'xs',
            paddingInline: 'spacing-4',
            color: 'text.secondary',
            textDecoration: 'line-through'
        },
        priceContainer: {
            display: 'flex',
            alignItems: 'center',
            color: 'text.secondary'
        },
        taxesLabel: {
            color: 'text.tertiary'
        }
    },
    variants: {
        showVatLabel: {
            true: {},
            false: {
                taxesLabel: {
                    display: 'none'
                }
            }
        },
        size: {
            md: {
                originalPrice: {
                    textStyle: 'body.small'
                },
                price: {
                    textStyle: 'heading.xlarge'
                },
                freeLabel: {
                    textStyle: 'heading.xlarge'
                },
                taxesLabel: {
                    textStyle: 'body.xsmall'
                }
            },
            sm: {
                originalPrice: {
                    textStyle: 'body.small'
                },
                price: {
                    textStyle: 'heading.medium'
                },
                freeLabel: {
                    textStyle: 'heading.medium'
                },
                taxesLabel: {
                    display: 'none'
                }
            },
            xs: {
                originalPrice: {
                    textStyle: 'body.xsmall'
                },
                price: {
                    textStyle: 'heading.small'
                },
                freeLabel: {
                    textStyle: 'heading.small'
                },
                taxesLabel: {
                    display: 'none'
                }
            }
        },
        alignment: {
            start: {
                container: {
                    alignItems: 'flex-start'
                },
                priceOrder: {
                    justifyContent: 'flex-start'
                },
                taxesLabel: {
                    alignSelf: 'flex-start'
                }
            },
            center: {
                container: {
                    alignItems: 'center'
                },
                priceOrder: {
                    justifyContent: 'center'
                },
                taxesLabel: {
                    alignSelf: 'flex-start'
                }
            },
            end: {
                container: {
                    alignItems: 'flex-end'
                },
                priceOrder: {
                    justifyContent: 'flex-end'
                },
                taxesLabel: {
                    alignSelf: 'flex-start'
                }
            }
        }
    },
    defaultVariants: {
        size: 'md',
        alignment: 'start',
        showVatLabel: false
    }
})

export default displayPriceRecipe
